import { render } from "./ModalEditarCliente.vue?vue&type=template&id=49402495&scoped=true"
import script from "./ModalEditarCliente.vue?vue&type=script&lang=js"
export * from "./ModalEditarCliente.vue?vue&type=script&lang=js"

import "./ModalEditarCliente.vue?vue&type=style&index=0&id=49402495&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49402495"]])

export default __exports__